import { Product, Footer } from '../components';

function Home() {
  return (
    <>
      <Product />
      <Footer />
    </>
  );
}

export default Home;
